<template>
<v-list>
  <v-list-tile @click='$emit("selected")'  >
    <v-list-tile-avatar >
      <img v-if='profilePic' :src='profilePic' />
      <v-icon v-else >account_circle</v-icon>
    </v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-title >
        {{practitioner.first_name}} {{practitioner.last_name}}
      </v-list-tile-title>
    </v-list-tile-content>
    <v-list-tile-action v-if='withDropdown' >
      <v-icon>keyboard_arrow_down</v-icon>
    </v-list-tile-action>
  </v-list-tile>
</v-list>
</template>

<script>
export default {
  name: 'UserStatus',
  props: {
    practitioner: { type: Object },
    withDropdown: { type: Boolean, default: false }
  },
  computed: {
    profilePic () {
      return this.getObjectPath(this.practitioner, 'profile.profile_picture', false)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// UserStatus.vue?5965c191